import React from "react";
import { Outlet, Route, Routes } from "react-router-dom";
import StudentsPage from "../Admin/StudentsPage";
import TeachersPage from "../Admin/TeachersPage";
import Applications from "../Admin/Applications";
import AccountDocs from "../Admin/AccountDocs";
import { auth } from "./../../store/auth";
import { observer } from "mobx-react-lite";
import { appName } from "../../Service/http";
export default observer(function AdminIndexPage() {
  return (
    <div className="LayoutPage">
      <Routes>
        <Route path={`/${appName}`} element={<StudentsPage />} />
        <Route path={`/${appName}/students`} element={<StudentsPage />} />
        <Route path={`/${appName}/teachers`} element={<TeachersPage />} />
        {auth.user.data.AVN_BT_report === 1 && (
          <>
            <Route path={`/${appName}/applications`} element={<Applications />} />
            <Route path={`/${appName}/registration`} element={<AccountDocs />} />
          </>
        )}
      </Routes>
      <Outlet />
    </div>
  );
});
